module.exports = __webpack_public_path__ + "img/image_casa.ebb39f52.svg";